import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { getStrategiesByType } from '@/utils/recommendation-strategies';

export const AI_SUPPORTED_UPSELL_STRATEGIES = getStrategiesByType([
  RecommendationType.MANUAL,
  RecommendationType.MOST_POPULAR,
  RecommendationType.PERSONALIZED,
  RecommendationType.VIEWD_TOGETHER,
  RecommendationType.PURCHASED_TOGETHER,
  RecommendationType.NEW_ARRIVALS,
  RecommendationType.PAST_PURCHASES,
  RecommendationType.RECENTLY_VIEWED,
  RecommendationType.PURCHASED_WITH_RECENTLY_PURCHASED,
  RecommendationType.VIEWED_WITH_RECENTLY_VIEWED,
]);
